export default "__VITE_ASSET__0d89150b__"